import type { SuggestionKeyDownProps, SuggestionProps } from "@tiptap/suggestion";
import { forwardRef } from "react";

import { useEscapeKey } from "@hooks/useEscapeKey";
import { RelatedItem } from "@app-types/related-items.type";
import { TaggingComponent } from "../../../../components/TaggingComponent/TaggingComponent";

export type IMentionListProps = SuggestionProps<RelatedItem> & {
  onChange: (item: RelatedItem) => void;
  onClose: () => void;
};

type MentionListRef = {
  onKeyDown: (event: SuggestionKeyDownProps) => boolean;
};

export const MentionList = forwardRef<MentionListRef, IMentionListProps>(
  ({ query, onChange, onClose }, ref) => {
    useEscapeKey({
      callback: onClose,
      enabled: true,
    });

    return (
      <div
        className="max-w-sm divide-y divide-stroke-primary dark:divide-gray-600 rounded-md border border-stroke-primary bg-white shadow-navItem"
        role="listbox"
      >
        <TaggingComponent
          query={query}
          isCompact
          isInputHidden
          onChange={() => {}}
          onSelect={(value: RelatedItem) => onChange(value)}
          excludedIds={[]}
          keyForTypes="GLOBAL_SEARCH"
          uppercaseLabels
        />
      </div>
    );
  }
);
